import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const NotificationsContext = createContext({ badges: {}, totalBadges: 0 });

export function NotificationsProvider({ children }) {
  const { token } = useAuth();
  const [badges, setBadges] = useState({
    conges: 0,
    validation_heures: 0,
    avertissements: 0,
    todos: 0,
    incidents: 0,
  });

  const fetchBadges = async () => {
    if (!token) return;
    try {
      const res = await fetch(`${window.__API_URL__ || ""}/api/notifications/badges`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setBadges(data);
      }
    } catch (e) { /* ignore */ }
  };

  useEffect(() => {
    fetchBadges();
    const interval = setInterval(fetchBadges, 60000); // Refresh every minute
    return () => clearInterval(interval);
  }, [token]);

  const totalBadges = Object.values(badges).reduce((a, b) => a + b, 0);

  return (
    <NotificationsContext.Provider value={{ badges, totalBadges, refreshBadges: fetchBadges }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationsContext);
